<template>
  <div>
    <div :class="$style.container">
      <div :class="$style.wrapper">
        <div :class="$style.title">
          {{ $t('program.programInformation') }}
        </div>
        <div :class="$style.info">
          <div>{{ currentConfig.info }}</div>
          <div>{{ currentVersion }}</div>
        </div>
        <div :class="$style.info">
          <div :class="$style.copyright">
            <span>{{ currentConfig.copyright }} {{ new Date().getFullYear() }}</span>
            <span>{{ currentConfig.right }}</span>
          </div>
          <div>{{ $t('program.allRightsReserved') }}</div>
        </div>
        <div
          v-if="currentConfig.details"
          :class="$style.info"
        >
          <div>{{ currentConfig.details.website }}</div>
          <a
            :class="$style.link"
            :href="`${currentConfig.details.link}`"
            target="_blank"
          >
            {{ currentConfig.details.link }}
          </a>
        </div>
        <div
          v-if="currentConfig.details"
          :class="$style.info"
        >
          <div>E-mail:</div>
          <a
            :class="$style.link"
            :href="`mailto:${currentConfig.details.link}`"
            target="_blank"
          >
            {{ currentConfig.details.email }}
          </a>
        </div>
      </div>
      <img
        :class="$style.image"
        :src="currentConfig.img"
        :alt="currentConfig.productName"
      >
    </div>
    <div :class="$style.container">
      <div :class="$style.wrapper">
        <div :class="$style.title">
          {{ $t('program.registrationInformation') }}
        </div>
        <div :class="$style.info">
          <div>{{ $t('program.username') }}</div>
          <div>{{ userName }}</div>
        </div>
        <div :class="$style.info">
          <div>{{ this.$t('program.userEmail') }}</div>
          <div>{{ userEmail }}</div>
        </div>
        <div :class="$style.info">
          <div>{{ $t('program.companyName') }}</div>
          <div>{{ companyName }}</div>
        </div>
        <div :class="$style.info">
          <div>{{ $t('program.numberOfComputers') }}</div>
          <div>{{ numberOfComputers }}</div>
        </div>
        <div
          v-if="isUserNotRegistered"
          :class="$style.info"
        >
          <div>{{ $t('program.licenseExpiresIn') }}</div>
          <div>{{ dayTrial }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { currentConfig } from '@/config';

  export default {
    computed: {
      currentConfig() {
        return currentConfig;
      },
      isUserNotRegistered() {
        return this.$store.getters['software/isUserNotRegistered'];
      },
      currentVersion() {
        return this.$store.getters['software/currentVersion'];
      },
      userName() {
        return this.$store.getters['software/userName'] || this.$t('program.notRegistered');
      },
      userEmail() {
        return this.$store.getters['software/userEmail'] || this.$t('program.notRegistered');
      },
      companyName() {
        return this.$store.getters['software/companyName'] || this.$t('program.notRegistered');
      },
      numberOfComputers() {
        return this.$store.getters['software/numberOfComputers'] || ' ';
      },
      dayTrial() {
        const dayTrial = this.$store.getters['software/dayTrial'];
        return `${dayTrial} ${this.$t('global.days')}`;
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    display: flex;
    justify-content: space-between;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px auto 15px 22px;
    width: 92%;
    padding: 15px 25px;
  }
  .image {
    height: 250px;
  }
  .title {
    font-weight: 500;
  }
  .info {
    display: grid;
    grid-template-columns: 250px 1fr;
    column-gap: 20px;
    margin: 20px;
    height: 30px;
    align-items: center;
  }
  .copyright {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .link {
    color: #1788ce;
  }
</style>
